import React from 'react';
import VoxelTooltipShort from '../Tooltip/VoxelTooltipShort';

export interface VoxelHorPanelTabProps {
  title: string;
  active?: boolean;
  onClick?: () => void;
  tooltip?: string;
}

export const VoxelHorPanelTab: React.FC<VoxelHorPanelTabProps> = ({
  title,
  active = false,
  onClick,
  tooltip,
}) => {
  return (
    <VoxelTooltipShort message={tooltip} disabled={!tooltip?.length}>
      <li
        onClick={onClick}
        className={`
            select-none
            ${!active && 'cursor-pointer'}
            ${active && 'cursor-default'}
            rounded-t-xl
            shadow-horTabs
            pl-6 pr-7 py-2
            font-sans font-semibold text-sm text-center float-left capitalize
            transition duration-50
            ${active && 'bg-white text-primary-800 z-3'}
            ${!active && 'bg-voxel-gray-100 hover:bg-voxel-gray-50 text-voxel-gray-700'}
      `}
      >
        {title}
      </li>
    </VoxelTooltipShort>
  );
};

export default VoxelHorPanelTab;
